import React from 'react';
import RadioFieldset from '../../audi-ui-components/RadioFieldset';
import TradeinForm from './TradeinForm';

class TradeinModule extends React.Component {

    componentDidMount() {
        // https://github.com/jaredpalmer/formik/issues/930
        let tradeInVal = this.props.alwaysShowForm ? "true" : "";
        setTimeout(() => {
            this.props.setValues(
                Object.assign({}, this.props.values, {
                    tradeIn: tradeInVal,
                    tradeState: "",
                    tradeRego: "",
                    tradeMakeCode: "",
                    tradeMake: "",
                    tradeFamilyCode: "",
                    tradeModel: "",
                    tradeYear: "",
                    tradeKms: "",
                    tradeHasFinance: "",
                    redbookcode: ""
                })
            );
        }, 50);
    }

    render() {
        const {title, description, alwaysShowForm, theme} = this.props;
        return (
            <div className="tradein-module form-module">
                {title && <p className="aui-headline-5 mb-2">{title}</p>}
                {description && <p className="mb-2">{description}</p>}
                {!alwaysShowForm && <RadioFieldset name="tradeIn"
                    value={this.props.values.tradeIn}
                    label=""
                    options={[
                        { label: 'Yes please', value: 'true' },
                        { label: 'No thanks', value: 'false' },
                    ]}
                    onChange={(v) => {
                        this.props.setFieldValue("tradeIn", v);
                    }}
                />}
                {(this.props.values.tradeIn === 'true' || alwaysShowForm) &&
                    <TradeinForm {...this.props} theme={theme} />
                }
            </div>
        );
    }
}

TradeinModule.defaultProps = {
    alwaysShowForm: false,
    hasExtraFields: true,
    title: "Trade-in",
    description: "Your purchase experience should be as easy as possible. Would you like your dealer to provide a trade-in appraisal on your current vehicle and remove the hassle of selling it privately?"
};

export default TradeinModule;
